import every from 'lodash/every';
import { getNumberFormatter } from '../../../utilities/getNumberFormatter';

const currencyFormatter = getNumberFormatter();

export const getters = {
  apr: state => state.apr,
  amount: state => state.amount,
  amountAsCurrencyString:
    (state, { amount }) => currencyFormatter(amount),
  hasValidPrequalData: (state) => {
    return every(
      ['amount', 'apr', 'payment', 'term'],
      (param) => state[param] > 0
    );
  },
  payment: state => state.payment,
  paymentAsCurrencyString:
    (state, { payment }) => currencyFormatter(payment),
  term: state => state.term
};
